const isEmpty = field =>
  JSON.stringify(field) === "" || field === null || field === "";

export const useProductCreateValidation = initialForm => {
  const {
    basePrice,
    category,
    name,
    description,
    sku,
    weight,
    width,
    height,
    length,
    productStatus,
    isSimpleProduct
  } = initialForm;

  const includeValidation = Boolean(
    isSimpleProduct && productStatus === "READY"
  );

  const validateRequiredField = data =>
    isEmpty(data) ? "This field is required" : null;

  const richTextRequiredField = data => {
    if (data === null) {
      return "This field is required";
    }
    return null;
  };

  return {
    basePrice: includeValidation ? validateRequiredField(basePrice) : null,
    category:
      productStatus === "READY" ? validateRequiredField(category) : null,
    description: richTextRequiredField(description),
    height: includeValidation ? validateRequiredField(height) : null,
    isSimpleProduct: null,
    length: includeValidation ? validateRequiredField(length) : null,
    name: validateRequiredField(name),
    productStatus: null,
    sku: isSimpleProduct ? validateRequiredField(sku) : null,
    weight: includeValidation ? validateRequiredField(weight) : null,
    width: includeValidation ? validateRequiredField(width) : null
  };
};

export const useProductVariantValidation = initialForm => {
  const { price, sku, weight, width, height, length } = initialForm;

  const validateRequiredField = data =>
    isEmpty(data) ? "This field is required" : null;

  return {
    height: validateRequiredField(height),
    length: validateRequiredField(length),
    price: validateRequiredField(price),
    sku: validateRequiredField(sku),
    weight: validateRequiredField(weight),
    width: validateRequiredField(width)
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });

  return thisReturn;
};
